import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';

import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class TechnicianService {
  private apiURL: string = '';
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
    this.env = this.appConfig.getEnvironmentNew();
  }

  getTechnician(technicianID: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + '/api/Technician/' + technicianID, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveTechnician(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + '/api/Technician', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateTechnician(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .put(this.apiURL + '/api/Technician', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getTechnicianWorkHours(technicianID: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + '/api/Technician/' + technicianID + '/WorkingHours',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveTechnicianWorkHours(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + '/api/Technician/WorkingHours', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getTechnicianEvents(technicianID: string, fromDate: string, toDate: string) {
    let data = { ID: technicianID, FromDate: fromDate, ToDate: toDate };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Technician/SearchCalendarEvents',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  createCalendarEvent(
    technicianID: number,
    description: string,
    fromDate: string,
    toDate: string,
    isRecurring: boolean,
    recurringCount: number,
    recurringIntervalDays: number,
  ) {
    let data = {
      TechnicianID: technicianID,
      Description: description,
      StartTime: fromDate,
      EndTime: toDate,
      IsRecurringEvent: isRecurring,
      RecurringCount: recurringCount,
      RecurIntervalDays: recurringIntervalDays,
    };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Technician/CreateCalendarEvent',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  createCalendarEventRecurring(
    technicianID: number,
    description: string,
    fromDate: string,
    toDate: string,
    isRecurring: boolean,
    Monday: boolean,
    Tuesday: boolean,
    Wednesday: boolean,
    Thursday: boolean,
    Friday: boolean,
    Saturday: boolean,
    Sunday: boolean,
    endDate: string,
  ) {
    let data = {
      TechnicianID: technicianID,
      Description: description,
      StartTime: fromDate,
      EndTime: toDate,
      IsRecurringEvent: isRecurring,
      Monday: Monday,
      Tuesday: Tuesday,
      Wednesday: Wednesday,
      Thursday: Thursday,
      Friday: Friday,
      Saturday: Saturday,
      Sunday: Sunday,
      EndDate: endDate,
    };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Technician/CreateCalendarEventRecurring',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  updateCalendarEvent(
    id: number,
    technicianID: number,
    description: string,
    fromDate: string,
    toDate: string,
    recurrenceID: number,
    duration: number,
    isActive: boolean,
  ) {
    let data = {
      ID: id,
      TechnicianID: technicianID,
      Description: description,
      StartTime: fromDate,
      EndTime: toDate,
      RecurrenceID: recurrenceID,
      Duration: duration,
      IsActive: isActive,
    };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Technician/UpdateCalendarEvent',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateCalendarEventAll(
    id: number,
    technicianID: number,
    description: string,
    fromDate: string,
    toDate: string,
    recurrenceID: number,
    duration: number,
    isActive: boolean,
  ) {
    let data = {
      ID: id,
      TechnicianID: technicianID,
      Description: description,
      StartTime: fromDate,
      EndTime: toDate,
      RecurrenceID: recurrenceID,
      Duration: duration,
      IsActive: isActive,
    };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Technician/UpdateCalendarEventAll',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  cancelCalendarEvent(
    technicianID: number,
    eventID: number,
    removeAll: boolean,
  ) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
          `/api/Technician/${technicianID}/CancelEvent/${eventID}/AllOccurences/${removeAll}`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getTechniciansAvailability(PartnerID, Date, Technicians) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/v4.0/Services/TechniciansAvailabilityV2?PartnerID=${PartnerID}&Date=${Date}&Technicians=${Technicians}&code=` +
          this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getTechniciansAvailabilityDateRange(
    PartnerID,
    FromDate,
    ToDate,
    Technicians,
  ) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/v4.0/Services/TechniciansAvailabilityV3?PartnerID=${PartnerID}&FromDate=${FromDate}&ToDate=${ToDate}&Technicians=${Technicians}&code=` +
          this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getTechniciansLinkedServices(technicianID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Technician/${technicianID}/ServiceTypes?code=` +
          this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateTechniciansLinkedServices(technicianID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
          `/Technician/${technicianID}/ServiceTypes?code=` +
          this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getTechniciansLinkedFittings(technicianID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Technician/${technicianID}/Fittings?code=` +
          this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateTechniciansLinkedFittings(technicianID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
          `/Technician/${technicianID}/Fittings?code=` +
          this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getTechnicianiAvailabilitySettings(technicianID, fromDate, toDate) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Technician/${technicianID}/Availability/Settings?FromDate=${fromDate}&ToDate=${toDate}&code=` +
          this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateTechnicianDefaultHours(technicianID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
          `/Technician/${technicianID}/DefaultHours?code=` +
          this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateTechnicianActualHours(technicianID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
          `/Technician/${technicianID}/ActualHours?code=` +
          this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getTechnicianOpenSlots(partnerID, technicianID, date, services) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Services/TechniciansAvailableSlots?PartnerID=${partnerID}&TechnicianID=${technicianID}&Date=${date}&Services=${services}&code=` +
          this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
}
